import {
  BUSINESS_TYPE_LIST_SEARCH, BUSINESS_TYPE_LIST_SEARCH_FAILURE, BUSINESS_TYPE_LIST_SEARCH_SUCCESS, BUSINESS_TYPE_DELETE, BUSINESS_TYPE_DELETE_FAILURE, BUSINESS_TYPE_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    businesstypes: [],
    businesstypeListNextPage: null,
    businesstypeListCurrentPage: null
  },
  getters: {
    businesstypeList: state => {
      return state.businesstypes
    },
    businesstypeListNextPage: state => {
      return state.businesstypeListNextPage
    },
    businesstypeListCurrentPage: state => {
      return state.businesstypeListCurrentPage
    }
  },
  actions: {
    [BUSINESS_TYPE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/business_types'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(BUSINESS_TYPE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(BUSINESS_TYPE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [BUSINESS_TYPE_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('BUSINESS_TYPE_DELETE:' + params.id)
      var data = params.data
      var url = '/master/business_types/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(BUSINESS_TYPE_DELETE_FAILURE, res.data)
          } else {
            commit(BUSINESS_TYPE_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [BUSINESS_TYPE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('BUSINESS_TYPE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [BUSINESS_TYPE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('BUSINESS_TYPE_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.businesstypes = state.businesstypes.concat(data.data)
        state.businesstypeListCurrentPage = data.meta['current-page']
      } else {
        state.businesstypes = data.data
        state.businesstypeListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.businesstypeListNextPage = data.links['next']
      } else {
        state.businesstypeListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [BUSINESS_TYPE_DELETE_FAILURE] (state, data) {
      console.log('BUSINESS_TYPE_DELETE_FAILURE')
    },
    [BUSINESS_TYPE_DELETE_SUCCESS] (state, data) {
      console.log('BUSINESS_TYPE_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/businesstype-list.js